import { observer } from 'mobx-react-lite';
import React, { useEffect, } from 'react';
import { Outlet } from 'react-router-dom';
import sensorBatchStore from '../stores/sensor-batch-store';
import LowSpinner from '../../../../components/common/low-spinner';

const SensorBatchLoader: React.FC = observer(() => {

    const { sensorBatches, loadAllSensorBatches } = sensorBatchStore;

    useEffect(() => {
        if (!sensorBatches.length) {
            loadAllSensorBatches();
        }
    },[]);

    if (!sensorBatches.length) {
        return <LowSpinner id={"sensorBatch.loading"} />;
    }
    else {
        return <Outlet />
    }
});
export default SensorBatchLoader;